import { UserDto } from "../DTOs/User/UserDto";
import { hasArea } from "../utilities/helpers/roleUtilities";

/**
 * Which of the prefetcher's area-gated feeds the user can read, each keyed to the area its endpoint's
 * [AreaAuthorize] names. Everything else it warms is an AreaFree lookup and needs no plan.
 */
export const prefetchPlan = (user: UserDto | null) => {
  const operations = hasArea(user, "Operations");
  const stoppages = hasArea(user, "Stoppages");

  return {
    rehandle: hasArea(user, "GeologyRehandle"),
    crushing: hasArea(user, "GeologyCrushing"),
    stoppages,
    operations,
    plantStoppages: operations && stoppages,
    diggingSummary: hasArea(user, "DiggingLoadingSummary"),
    diggerShift: hasArea(user, "Production") || hasArea(user, "DiggingLoadingSummary"),
  };
};
